'use client';
import '@rmwc/checkbox/styles';
import {
  Checkbox as RMWCCheckbox,
  type CheckboxProps,
  type CheckboxHTMLProps,
} from '@rmwc/checkbox';
import styles from './Checkbox.module.scss';
import {clsx} from 'clsx';

const Checkbox = (
  props: Partial<
    CheckboxProps &
      CheckboxHTMLProps & {className: string; disableRipple: boolean}
  >,
): React.JSX.Element => {
  return (
    <RMWCCheckbox
      {...props}
      className={clsx(
        props.className,
        styles.checkbox,
        props.disableRipple && styles.disableRipple,
      )}
    />
  );
};

export {Checkbox};
